import BaseLayout from "@/components/base/BaseLayout.vue";
var info = {
    components: {
        BaseLayout
    }
};

export default info;